import React from 'react';
import { cloneChildrenWithProps, } from '../../../jsCore/utils/reactUtils';


export function StatsWrapper({ children, }) {
  const blockName = 'stats';
  return (
    <ul className={ blockName }>
      { cloneChildrenWithProps(children, { blockName }) }
    </ul>
  );
}


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/post_metadata/components/StatsWrapper.js